var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00444 54.7378C-1.2 45.04 -1.80445 28.7556 4.13333 18.1689C16.3289 -3.78665 55.2178 0.915577 58.0089 8.45335C59.6889 13.0311 48.7556 20.4089 51.2978 24.7556C53.1733 27.9734 59.8044 25.0845 62.5156 28.3822C66.1778 32.8267 60.6844 46.16 51.4756 53.5645C41.2355 61.7778 21.5111 66.5778 9.00444 54.7378Z",
    fill: "#FDDC9D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_649_83896",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 62
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00444 54.7378C-1.2 45.04 -1.80445 28.7556 4.13333 18.1689C-12.3378 -7.50218 55.2178 0.915593 58.0089 8.45337C59.6889 13.0311 48.7556 20.4089 51.2978 24.7556C53.1733 27.9734 59.8044 25.0845 62.5156 28.3823C66.1778 32.8267 60.6844 46.16 51.4756 53.5645C41.2355 61.7778 21.5111 66.5778 9.00444 54.7378Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_649_83896)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6089 66.9333L47.9467 66.8089L47.76 12.1422C47.7511 8.79111 45.52 6.08 42.7911 6.08889L8.75555 6.20444L11.4133 10.3378L11.6089 66.9333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3422 6.07999L6.43555 6.20444C4.94222 6.20444 3.74222 7.76888 3.75111 9.68888L3.77778 17.7422L10.8533 17.7156L11.0222 67.2711C11.0222 68.7556 11.9644 69.9556 13.1111 69.9467L46.6222 69.8311C47.7689 69.8311 48.7022 68.6222 48.6933 67.1378L48.5067 12.4267C48.4356 8.83555 46.1244 5.9911 43.3422 6.0711V6.07999Z",
    fill: "url(#paint0_linear_649_83896)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.76889 17.7689L10.9422 17.7422L10.9156 9.68889C10.9156 7.78667 9.74222 6.23111 8.26667 6.19556H6.42667C4.93333 6.20445 3.73333 7.76889 3.74222 9.68889L3.76889 17.7689Z",
    fill: "#7698CB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M42.5211 16.8826L16.7257 16.9727L16.7318 18.7149L42.5272 18.6248L42.5211 16.8826Z",
    fill: "#A7A6BD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M42.5408 22.5269L16.7454 22.6169L16.7515 24.3592L42.5469 24.2691L42.5408 22.5269Z",
    fill: "#A7A6BD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M42.5605 28.1801L16.7651 28.2701L16.7712 30.0124L42.5666 29.9223L42.5605 28.1801Z",
    fill: "#A7A6BD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M42.5891 33.8334L16.7937 33.9235L16.7998 35.6657L42.5952 35.5756L42.5891 33.8334Z",
    fill: "#A7A6BD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M42.5999 39.4777L16.8045 39.5677L16.8106 41.31L42.606 41.2199L42.5999 39.4777Z",
    fill: "#A7A6BD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33.8819 50.2458L16.8421 50.3053L16.8481 52.0475L33.888 51.988L33.8819 50.2458Z",
    fill: "#A7A6BD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M42.6187 44.8465L16.8233 44.9365L16.8293 46.6787L42.6247 46.5887L42.6187 44.8465Z",
    fill: "#A7A6BD"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9822 34.1156C59.5556 34.7734 58.6933 34.9511 58.0356 34.5245L48.8356 28.5245C49.1467 28.2045 49.4222 27.8578 49.6711 27.4756C49.9556 27.0578 50.1778 26.6045 50.3556 26.16L59.5733 32.1778C60.2222 32.5956 60.4089 33.4667 59.9822 34.1156Z",
    fill: "#FF614E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.48 15.52C44.1422 12.6934 38.3289 13.9111 35.5111 18.2489C32.6844 22.5867 33.9022 28.3822 38.24 31.2178C42.5778 34.0445 48.3733 32.8267 51.2089 28.4889C54.0267 24.1511 52.8178 18.3556 48.48 15.52ZM49.6622 27.4934C47.3956 30.9689 42.72 31.9467 39.2356 29.68C35.76 27.4134 34.7822 22.7378 37.0489 19.2623C39.3156 15.7778 43.9822 14.8 47.4667 17.0667C50.9511 19.3334 51.9289 24.0089 49.6622 27.4934Z",
    fill: "#FF614E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M50.3556 26.1689C50.1778 26.6134 49.9556 27.0667 49.6711 27.4845C49.4311 27.8667 49.1467 28.2134 48.8356 28.5334C46.3911 31.1378 42.3378 31.6889 39.2356 29.6712C35.76 27.4045 34.7822 22.7289 37.0489 19.2534C39.3156 15.7689 43.9822 14.7912 47.4667 17.0578C50.5333 19.0489 51.6622 22.8978 50.3467 26.1689H50.3556Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49778 29.7066H5.65334L6.08 26.6755L6.50667 29.7066H6.49778Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49778 29.7067H5.65334L6.08 32.7378L6.50667 29.7067H6.49778Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08 30.1334V29.28L9.10222 29.7067L6.08 30.1334Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08 30.1334V29.28L3.04889 29.7067L6.08 30.1334Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2355 44.9511H52.56L52.8978 42.5244L53.2355 44.9511Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2355 44.951H52.56L52.8978 47.3777L53.2355 44.951Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8978 45.2888V44.6044L55.3245 44.9421L52.8978 45.2888Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8978 45.2888V44.6044L50.4711 44.9421L52.8978 45.2888Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_649_83896",
    x1: -13.9022,
    y1: 37.6444,
    x2: 252.862,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FCFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F2F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#E1DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C9C7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#AAA6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8580FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.38de5e2770ed6ca5e105012c90a2b3cf.svg";
export { ForwardRef as ReactComponent };